import ApiService from "../../../../services/ApiService";

export const fetchUserExams = (userId: number, setExams: Function, setLoading: Function) => {
  setLoading(true);
  ApiService.get(`users/${userId}/evaluation_attempts?fetch_corrector=true`)
    .then((response) => setExams(response.data.evaluation_attempts))
    .catch((error) => console.error("An error occurred while fetching user's exams", error))
    .finally(() => setLoading(false));
};

export const getStatus = (status: string): string => {
  switch (status?.toLowerCase()) {
    case "in progress":
    case "correction pending":
    case "being corrected":
      return "status-orange";
    case "corrected":
    case "success":
      return "status-green";
    case "repass":
    case "failed":
      return "status-red";
    case "created":
      return "status-blue";
    default:
      return "";
  }
};
